"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PrescriptionPillOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path d="M23.78 8.22a1 1 0 1 0-1.413 1.415c.314.314.392 1.022-.177 1.59l-2.652 2.652a1 1 0 0 0 1.415 1.415l2.651-2.652c1.189-1.189 1.425-3.172.177-4.42z"></path><path fill-rule="evenodd" d="M25.899 14.588a6.004 6.004 0 0 0-8.245-8.726l-.01.01c-.08.072-.159.147-.236.225L6.1 17.404a6.004 6.004 0 1 0 8.492 8.491l11.307-11.307zm-1.414-1.414-4.947 4.946-5.656-5.657 5.135-5.135a4.005 4.005 0 0 1 5.468 5.846zm-16.97 5.644 4.946-4.947 5.663 5.663-4.946 4.947a4.004 4.004 0 0 1-5.663-5.663z" clip-rule="evenodd"></path></g>';
var PrescriptionPillOutlineSVG = function PrescriptionPillOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PrescriptionPillOutlineSVG = PrescriptionPillOutlineSVG;
PrescriptionPillOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PrescriptionPillOutlineSVG);
exports.default = _default;